import { render, staticRenderFns } from "./buy.vue?vue&type=template&id=dd81af1e&scoped=true"
import script from "./buy.vue?vue&type=script&lang=ts"
export * from "./buy.vue?vue&type=script&lang=ts"
import style0 from "./buy.vue?vue&type=style&index=0&id=dd81af1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd81af1e",
  null
  
)

export default component.exports